import { Grid, styled } from "@mui/material"

const GridContainer = styled(Grid)(() => ({
    borderRight: "solid",
    borderRightColor: "#e0e0e0",
    borderWidth: "2px",
    position: "sticky",
}));

const Sidebar: React.FC = (props) => {
    return (
        <GridContainer container>
            {props.children}
        </GridContainer>
    )
}

export default Sidebar